export { default } from './CollapsibleMonitoringTable';
